import { useState } from 'react';
import Input from '../input/Input';
import { HideIcon, PreviewIcon } from '../icons';

export interface PasswordInputProps {
    id: string;
    label?: string;
    name: string;
    updateField: (name: string, value: any) => void;
    error?: boolean;
    helperText?: string;
    showToggle?: boolean;
    disabled?: boolean;
}

const Passwordinput = ({
    id,
    label,
    name,
    updateField,
    error,
    helperText,
    showToggle = false,
    disabled = false
}: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div>
            <Input
                errorMessage={error ? helperText : undefined}
                infoText={helperText}
                id={id}
                type={showPassword ? 'text' : 'password'}
                label={label}
                className='text-sm'
                disabled={disabled}
                rightIcon={
                    showToggle && (
                        <div
                            className='cursor-pointer'
                            onClick={() => setShowPassword((prev) => !prev)}
                        >
                            {!showPassword ? (
                                <PreviewIcon color='#1D29395a' />
                            ) : (
                                <HideIcon color='#1D29395a' />
                            )}
                        </div>
                    )
                }
                name={name}
                onChange={(e) => {
                    updateField(name, e.target.value);
                }}
            />
        </div>
    );
};

Passwordinput.defaultProps = {
    label: 'Password'
};

export default Passwordinput;
